var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFusoChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#EBEBEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_15567)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9804 5L9.31819 9.67496L11.9778 14.3339H6.65858L4 19H9.31923L11.9783 14.3349L14.641 19H20L17.2975 14.3339H11.9788L14.6343 9.67496L11.9804 5Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_15567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "white",
    transform: "translate(4 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFusoChat);
export default __webpack_public_path__ + "static/media/fusoChat.f566c43685d856cbf8f3bc1951a870ee.svg";
export { ForwardRef as ReactComponent };